import angular from 'angular';
import adminUserAddFormComponent from './admin-user-add-form.component';

export default angular.module('components.app.admin.adminUserAddForm', [])
  .component('adminUserAddForm', adminUserAddFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-add-form/admin-user-add-form.module.js